// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  connectAuthEmulator,
} from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC7IiGIOmHCg1yecWmn_qL5gjYmlxoBvZ4",
  authDomain: "syrocatechism.firebaseapp.com",
  projectId: "syrocatechism",
  storageBucket: "syrocatechism.firebasestorage.app",
  messagingSenderId: "628897180882",
  appId: "1:628897180882:web:bbc4962222ee94f44ed10b",
  measurementId: "G-B8V5T3TGMX",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
const db = getFirestore(app);
const analytics = getAnalytics(app);

if (window.location.hostname === "localhost") {
  // Connect to Authentication Emulator
  connectAuthEmulator(auth, "http://localhost:9099");

  // Connect to Firestore Emulator
  connectFirestoreEmulator(db, "localhost", 8080);
}

export { auth, provider, db, analytics };
